<ion-content>
	<ion-row class="ion-justify-content-center padding-auth">
		@if (!loading) {
		<ion-col>
			<ion-row class="ion-justify-content-center">
				<ion-img class="ion-margin" src="/assets/icon/icon-maintenance.svg"></ion-img>
				<p class="bold font-18 align-center">
					{{ 'maintenance_page.title' | translate }}<br />
					{{ 'maintenance_page.sub_title' | translate }}
				</p>
				<p class="font-14 align-center">{{ 'maintenance_page.description' | translate }}</p>
			</ion-row>
			<ion-row>
				<ion-button (click)="reload()" class="ion-no-margin"> {{ 'maintenance_page.reload' | translate }} </ion-button>
			</ion-row>
		</ion-col>
		} @if (loading) {
		<ion-row class="ion-justify-content-center">
			<ion-spinner></ion-spinner>
		</ion-row>
		}
	</ion-row>
</ion-content>
